import {
  // BrowserRouter as Router,
  Switch,
  Route,
  useLocation
} from "react-router-dom";
import querySearch from 'stringquery';
import React, { useEffect, Suspense, lazy } from 'react';
import './App.css';
import { useTranslation } from 'react-i18next';

const Shell = lazy(() => import('./pages/CSLCodeless/Shell'));
const PaymentLoading = lazy(() => import('./pages/CSLCodeless/PaymentLoading'));
const FuturePayFail = lazy(() => import('./pages/CSLCodeless/FuturePayFail'));
const BindingSetup = lazy(() => import('./pages/CSLCodeless/BindingSetup'));
const BindingSuccess = lazy(() => import('./pages/CSLCodeless/BindingSuccess'));
const BindingRmConf = lazy(() => import('./pages/CSLCodeless/BindingRmConf'));
const SubConfirmation = lazy(() => import('./pages/CSLCodeless/SubConfirmation'));
const NoSubConfirmation = lazy(() => import('./pages/CSLCodeless/NoSubConfirmation'));
const CslLogin = lazy(() => import('./pages/CSLCodeless/CslLogin'));

function App() {
  let location = useLocation();
  let query = querySearch(location.search);
  const { lang } = query;

  const { i18n } = useTranslation();

  useEffect(() => {
    if (lang && ['en', 'zh'].includes(lang)) {
      i18n.changeLanguage(lang);
    }
  }, [i18n, lang]);

  return (
    <div>
      <div className="large-11 large-centered columns columns-none">
        <div className="row none-m">
          <div className="large-12 columns">
            <div className="row">
              <Suspense fallback={<div>Loading...</div>}>
                <Switch>
                  <Route path="/cslcodeless/shell" component={Shell} />
                  <Route path="/cslcodeless/paymentprocess" component={PaymentLoading} />
                  <Route path="/cslcodeless/futurepayfail" component={FuturePayFail} />
                  <Route path="/cslcodeless/bindingsetup" component={BindingSetup} />
                  <Route path="/cslcodeless/bindingsuccess" component={BindingSuccess} />
                  <Route path="/cslcodeless/subconfirmation" component={SubConfirmation} />
                  <Route path="/cslcodeless/nosubconfirmation" component={NoSubConfirmation}/>
                  <Route path="/cslcodeless/bindingrmConf" component={BindingRmConf}/>
                  <Route path="/cslcodeless/csllogin" component={CslLogin}/>
                </Switch>
              </Suspense>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
